@if (selector !== 'search-api') {
  <select-search-api
      [fetchData]="fetchData"
      (selectionChange)="emitEvent($event)"
      (closeWithoutChange)="closeWithoutChange.emit()"
      (showUpdate)="showUpdate.emit()"
      (accountsChange)="filterByAccount($event)"
      [openOnInit]="openOnInit"
      [placeholder]="placeholder"
      [required]="required"
      [allowAccountSelection]="allowAccountSelection"
      [allowedAccountIds]="allowedAccountIds"
      [disabled]="disabled"
      [compareFunctionName]="compareFunctionName"
      [stringFunction]="stringFunction"
      [value]="value"
      [init_value]="init_value"
      [allow_none]="allow_none"
      [label]="label"
      [panelClasses]="panelClasses"
      [classes]="classes"
      [noItemsAvailableMessage]="noItemsAvailableMessage"
      style="min-width:inherit;max-width:inherit;">
  </select-search-api>
}
@if (selector === 'search-api') {
  <search-api
      [fetchData]="fetchData"
      (selectionChange)="emitEvent($event)"
      (closeWithoutChange)="closeWithoutChange.emit()"
      (actionClicked)="actionClicked.emit($event)"
      [openOnInit]="openOnInit"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [allow_navigate]="allow_navigate"
      [compareFunctionName]="compareFunctionName"
      [stringFunction]="stringFunction"
      [value]="value"
      [label]="label"
      [classes]="classes"
      [action]="action"
      style="min-width:inherit;max-width:inherit;">
  </search-api>
}
